import type { Storage } from "../types/enums/Storage.enum"

const SaveLocalStorage = (key: Storage, value: any) => {
    localStorage.setItem(key, value)
}

const GetLocalStorage = (key: Storage) => {
    return localStorage.getItem(key)
}

const RemoveLocalStorage = (key: Storage) => {
    localStorage.removeItem(key)
}

const ClearLocalStorage = () => {
    localStorage.clear()
}

const UpdateLocalStorageObject = (key: Storage, partialValue: Partial<any>) => {
    // Leer el objeto existente (o usar un objeto vacío si no existe)
    const existingData: any | null = JSON.parse(GetLocalStorage(key)!);

    // Fusionar los datos nuevos con los existentes
    const updatedData: any = {
        ...existingData,
        ...partialValue
    } as any;

    // Guardar el objeto fusionado
    localStorage.setItem(key, JSON.stringify(updatedData));
};

export {
    SaveLocalStorage,
    GetLocalStorage,
    RemoveLocalStorage,
    ClearLocalStorage,
    UpdateLocalStorageObject
}